import Swiper from 'swiper/bundle';
import $ from 'jquery';

export default function contactSwiper() {
    let swiperContact = null;
    function initContactSwiper() {
        let screenWidth = window.innerWidth;
        if (screenWidth <= 992) {
            if (!swiperContact) {
                swiperContact = new Swiper(".avu-swiper-contact", {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 15,
                    rewind: true,
                    pagination: {
                        el: ".swiper-pagination-contact",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next-contact",
                        prevEl: ".swiper-button-prev-contact",
                    },
                });
            }
        } else {
            if (swiperContact) {
                swiperContact.destroy();
                swiperContact = null;
            }
        }
    }
    

    // Swiper plugin initialization
    if ($('.avu-swiper-contact').length > 0) {
        initContactSwiper();
    }
    
    // Swiper plugin initialization on window resize
    $(window).on('resize', function () {
        if ($('.avu-swiper-contact').length > 0) {
            initContactSwiper();
        }
    });

}
